// extracted by mini-css-extract-plugin
export default {"box":"number_box__2jbI9","number":"number_number__IUEXj","disabled":"number_disabled__2OMT4"};